// Docs from pdfMake at https://pdfmake.github.io/docs/
import { BYN_LOGO } from "@/plugins/bynLogo"
import pdfMake from "pdfmake/build/pdfmake"
import pdfFonts from "@/assets/fonts/vfs_fonts"
import get from 'lodash/get'
import Lcompact from 'lodash/compact'
import Sugar from "sugar"

pdfMake.vfs = pdfFonts;
pdfMake.fonts = {
  Dosis: {
    normal: 'Dosis-Regular.ttf',
    bold: 'Dosis-Bold.ttf',
    italics: 'Dosis-ExtraLight.ttf',
    bolditalics: 'Dosis-ExtraLight.ttf',
  },
  OpenSans: {
    normal: 'OpenSans-Regular.ttf',
    bold: 'OpenSans-Bold.ttf',
    italics: 'OpenSans-Regular.ttf',
    bolditalics: 'OpenSans-Bold.ttf',
  },
}

const formatCurrency = (value = 0) => {
  return Number(value).toLocaleString('sv-SE') + ' kr';
}

const formatOrgNumber = p => {
  try {
    const l = p.length;
    if (p && l > 9) return p.substring(0, l - 4) + '-' + p.substring(l - 4, l)
    return p
  } catch (error) {
    return ''
  }
}

const formatZipCode = zipCode => {
  return zipCode.replace(/(\d{3})/g, '$1 ').replace(/(^\s+|\s+$)/,'')
}

const Prints = {

  methods: {
    printPDF(docDefinition) {
      pdfMake.createPdf(docDefinition).print();
    },

    printOrder(order) {
      if (!order.createdBy) {
        order.createdBy = {
          firstName: '',
          lastName: '',
        }
      }
      let invEmail = ''
      if (get(order, 'company.workplaces.length', 0) > 0 && order.company.workplaces[0].invoiceAddressEmail)
        invEmail = order.company.workplaces[0].invoiceAddressEmail
       
      const orderDateFormated = order.orderedAt ? new Intl.DateTimeFormat('sv').format(new Date(order.orderedAt)) : '';

      /* Print orders define */
   
      if (order.type == "PrintOrder") {

        let student={
          firstName :get(order,'print.person.firstName',''),
          lastName :get(order,'print.person.lastName','')
        }
        let contactPerson={
          firstName :get(order.createdBy,'firstName',''),
          lastName :get(order.createdBy,'lastName','')
        }
        let options={
          costCenter: order.costCenter,
          invioceDeliveryMethod: order.invoiceEmail ?order.invioceDeliveryMethod =1 : order.invioceDeliveryMethod =0
        }
        
        order.student = student
        order.options = options
        order.contactPerson = contactPerson
  
      }

      const docDefinition = {
        pageOrientation: 'portrait',
        pageSize: 'A4',
        content: [
          {
            columns: [
              {
                svg: BYN_LOGO,
                width: 100,
                margin: [0, 0, 0, 0]
              },
              { text: 'Beställning', style: 'mainHeader' },
              [
                { text: 'BESTÄLLNINGSDATUM', style: 'fieldLabelOrderDate' },
                { text: orderDateFormated, style: 'fieldOrderDate' }
              ],
            ],
          },
          { text: '', style: 'header' },
          { text: '', style: 'header' },
          { text: '', style: 'header' },
          {
            columns: [
              [
                { text: 'AVSER', style: 'fieldLabel' },
                { text: order.type == "PrintOrder" ? 'Maskinkort':'Distansutbildning lärling', style: 'field' },
              ],
              [
                { text: 'LÄRLING', style: 'fieldLabel' },
                { text: order.student.firstName + ' ' + order.student.lastName, style: 'field' },
              ],
              [
                { text: 'FÖRETAG', style: 'fieldLabel' },
                { text: get(order, 'company.name', '') + ' ' + formatOrgNumber(get(order, 'company.organizationalNumber', null)), style: 'field' },
              ],
              [
                { text: 'FAKTURERINGSADRESS', style: 'fieldLabel' },
                { text: get(order, 'company.postalAddress1', ''), style: 'fieldAddress' },
                { text: get(order, 'company.postalZip', '') + ' ' + get(order, 'company.postalCity', ''), style: 'fieldAddress' },
                { text: invEmail, style: 'field' },
              ],
            ],
            columnGap: 20,
          },
          {
            columns: [
              [
                { text: 'BYN-REGION', style: 'fieldLabel' },
                { text: order.region.name, style: 'field' },
              ],
              [
                { text: 'BYN-HANDLÄGGARE', style: 'fieldLabel' },
                { text: order.createdBy.firstName + ' ' + order.createdBy.lastName, style: 'field' },
              ],
              [
                { text: 'FAKTURERINGSMETOD', style: 'fieldLabel' },
                { text: order.options && order.options.invioceDeliveryMethod == 1 ? 'E-post' : 'Pappersfaktura', style: 'field' },
              ],
              [
                { text: 'K-STÄLLE', style: 'fieldLabel' },
                { text: (order.options&&order.options.costCenter) || '', style: 'field' },
              ],
            ],
            columnGap: 20,
          },
          {
            columns: [
              [
                { text: 'STÄMPEL OCH ANTECKNINGAR', style: 'fieldLabel' },
                { canvas: [{ type: 'rect', x: 0, y: 0, h: 70, w: 230, r: 0, lineWidth: 0.5, lineColor: '#aaa', }] },
              ],
              {
                columns: [
                  [
                    { text: 'KONTAKTPERSON', style: 'fieldLabel' },
                    { text: get(order, 'contactPerson.firstName', '') + ' ' + get(order, 'contactPerson.lastName', ''), style: 'field' },
                    { text: 'E-POST', style: 'fieldLabel' },
                    { text: get(order, 'company.email', '') || get(order, 'createdBy.email', ''), style: 'field' },
                  ],
                  [
                    { text: 'TELEFON', style: 'fieldLabel' },
                    { text: get(order, 'company.phone', '') || get(order, 'createdBy.mobilephone', ''), style: 'field' },
                  ],
                ],
                columnGap: 20,
              }
            ],
            columnGap: 20,
          },
          { text: '', style: 'header' },
          { text: '', style: 'header' },
          {
            columns: [
              [
                { text: 'ORSAK', style: 'fieldLabel' },
                { text: get(order, 'reason', ''), style: 'field' },
              ],
            ]
          },
          { text: '', style: 'header' },
          { text: '', style: 'header' },
          { text: '', style: 'header' },
        ],
        styles: {
          mainHeader: {
            fontSize: 28,
            font: 'Dosis',
            margin: [100, 0, 100, 0],
            bold: false
          },
          header: {
            fontSize: 18,
            font: 'Dosis',
            margin: [0, 0, 0, 10],
            characterSpacing: 2
          },
          subheader: {
            fontSize: 16,
            margin: [0, 10, 0, 5],
          },
          fieldLabel: {
            fontSize: 7,
            font: 'Dosis',
            margin: [0, 10, 0, 2],
            characterSpacing: 1.0
          },
          field: {
            margin: [0, 0, 0, 20],
            fontSize: 9,
          },
          fieldAddress: {
            margin: [0, 0, 0, 0],
          },
          fieldLabelOrderDate: {
            fontSize: 7,
            font: 'Dosis',
            margin: [-14, 10, 0, 0],
            characterSpacing: 1.8
          },
          fieldOrderDate: {
            margin: [-14, 2, 0, 0],
          },
          tableHeader: {
            fontSize: 10,
            font: 'Dosis',
            bold: true,
            margin: [8, 8, 8, 4],
          },
          tableRow: {
            margin: [8, 8, 8, 4],
          },
          tableFooter: {
            margin: [8, 14, 8, 0],
            bold: true,
          },
        },
        defaultStyle: {
          fontSize: 10,
          font: 'OpenSans',
          color: '#3b3c3a',
        },
      };

      docDefinition.content.push([
        { canvas: [{ type: 'line', x1: 0, y1: 5, x2: 514, y2: 5, lineWidth: 0.5, lineColor: '#58d0d6' }] },
        {
          columns: [
            {
              width: '*',
              text: 'ORDER',
            },
            {
              width: 70,
              text: 'NETTO',
              alignment: 'right'
            },
          ],
          style: 'tableHeader',
        },
        { canvas: [{ type: 'line', x1: 0, y1: 5, x2: 514, y2: 5, lineWidth: 0.5, lineColor: '#58d0d6' }] },
      ]);
      let orderSum = 0;
      if (order && order.distanceOrderRows) {
        order.distanceOrderRows.forEach(r => {
          orderSum += r.price
          docDefinition.content.push({
            columns: [
              {
                width: '*',
                text: r.name,
              },
              {
                width: 70,
                text: formatCurrency(r.price),
                alignment: 'right'
              }
            ],
            style: 'tableRow',
          });
          docDefinition.content.push({
            canvas: [{ type: 'line', x1: 0, y1: 5, x2: 514, y2: 5, lineWidth: 0.5, lineColor: '#cccccc' }],
          });
        });
      }
      
      if (order.type == "PrintOrder") {
        let ret
        try {
          ret = Lcompact(order.print.formattedProfessions.split('\n'))
            .map(i => i.replace(/\t/i,' '))
            .join(', ')
        } catch (e) {
          ret = []
        }
        const itemText = order.printType=='TradeCertificate' ? `Yrkesbeviskort: ${ret}` : `Maskinkort: ${order.machines}`

        orderSum += order.price
        docDefinition.content.push({
          columns: [
            {
              width: '*',
              text: itemText,
            },
            {
              width: 70,
              text: formatCurrency(order.price),
              alignment: 'right'
            }
          ],
          style: 'tableRow',
        });
        docDefinition.content.push({
          canvas: [{ type: 'line', x1: 0, y1: 5, x2: 514, y2: 5, lineWidth: 0.5, lineColor: '#cccccc' }],
        });
      }

      docDefinition.content.push({ text: '', style: 'header' });
      docDefinition.content.push({ text: '', style: 'header' });

      docDefinition.content.push({
        columns: [
          {
            width: '*',
            text: 'Fakturabelopp (exkl. moms)',
          },
          {
            width: 70,
            text: formatCurrency(orderSum),
            alignment: 'right'
          },
        ],
        style: 'tableFooter',
      });
      pdfMake.createPdf(docDefinition).print();
    },

    _processDate(value) {
      if (!value) {
        return ''
      }
      const date = new Date(value)
      return (
        date.getFullYear() +
        '-' +
        (date.getMonth() < 9 ? '0' : '') +
        (date.getMonth() + 1) +
        '-' +
        (date.getDate() < 10 ? '0' : '') +
        date.getDate()
      )
    },

    _getTypeName(item) {
      if (item.type === 'ExtensionOrder') {
        return 'Förlängning grundutbildning';
      }
      
      return item.type == 'PrintOrder'? (item.printType=='TradeCertificate' ? 'Yrkesbeviskort' :'Maskinkort') :'Distansutbildning lärling'
    },
    
    // Accounting order
    printOrdersTable(headers, orders) {
      
      //- Include orders with type 'PrintType'
      const mappedOrders = orders.filter(o => o.type === 'PrintOrder').map(it => ([
        it.orderId,
        this._getTypeName(it),
        it.companyName,
        (it.contactPersonFirstName ?? it.firstName) + ' ' + (it.contactPersonLastName ?? it.lastName),
        it.regionName,
        it.stateName,
        it.firstName + ' ' + it.lastName,
        this._processDate(it.latestApprovalDate) || '-',
        this._processDate(it.sentToCompanyForApprovalAt || it.createdAt) || '-',
      ]))

      const mappedHeaders = headers.map(it => it.text);

      // Total price
      const totalPrice = orders.filter(o => o.type === 'PrintOrder').reduce((sum, item) => sum + item.price, 0)

      const docDefinition = {
        pageOrientation: 'portrait',
        pageSize: 'A4',
        content: [
          {
            layout: 'lightHorizontalLines',
            table: {
              headerRows: 1,
              widths: [20, 40, 60, 60, 'auto', 'auto', 'auto', 'auto', 'auto'],

              body: [
                mappedHeaders,
                ...mappedOrders,
              ]
            }
          }
        ],
        styles: {
          mainHeader: {
            fontSize: 28,
            font: 'Dosis',
            margin: [100, 0, 100, 0],
            bold: false
          },
          header: {
            fontSize: 18,
            font: 'Dosis',
            margin: [0, 0, 0, 10],
            characterSpacing: 2
          },
          subheader: {
            fontSize: 16,
            margin: [0, 10, 0, 5],
          },
          fieldLabel: {
            fontSize: 7,
            font: 'Dosis',
            margin: [0, 10, 0, 2],
            characterSpacing: 1.0
          },
          field: {
            margin: [0, 0, 0, 20],
            fontSize: 9,
          },
          fieldAddress: {
            margin: [0, 0, 0, 0],
          },
          fieldLabelOrderDate: {
            fontSize: 7,
            font: 'Dosis',
            margin: [-14, 10, 0, 0],
            characterSpacing: 1.8
          },
          fieldOrderDate: {
            margin: [-14, 2, 0, 0],
          },
          tableHeader: {
            fontSize: 10,
            font: 'Dosis',
            bold: true,
            margin: [8, 8, 8, 4],
          },
          tableRow: {
            margin: [8, 8, 8, 4],
          },
          tableFooter: {
            margin: [8, 14, 8, 0],
            bold: true,
          },
        },
        defaultStyle: {
          fontSize: 10,
          font: 'OpenSans',
          color: '#3b3c3a',
        },
      };

      docDefinition.content.push({
        columns: [
          {
            width: '*',
            text: 'Fakturabelopp (exkl. moms)',
          },
          {
            width: 70,
            text: formatCurrency(totalPrice),
            alignment: 'right'
          },
        ],
        style: 'tableFooter',
      });

      pdfMake.createPdf(docDefinition).print();
    },

    // New accounting orders layout
    newPrintOrdersTable(orders) {
      
      //- Include orders with certain conditions
      const condition = o => (o.type === 'PrintOrder' && [4, 6].includes(o?.stateId)) && o?.price > 0

      const mappedOrders = orders.filter(condition).map(it => ([
        it.orderId,
        this._getTypeName(it),
        it.personalNumber,
        it.firstName + ' ' + it.lastName,
        it.price,
        this._processDate(it.paidAt || it.createdAt),
      ]))

      const mappedHeaders = ['Fakturanr', 'Typ', 'Pnr', 'Namn', 'Pris', 'Betald']

      // Total price
      const totalPrice = orders.filter(condition).reduce((sum, item) => sum + item.price, 0)

      const priceWithoutVat = totalPrice / 1.25
      const vatAmount = totalPrice - priceWithoutVat

      const tableHeaders = [
        { text: 'BYN', bold: true, style: 'subheader' }, 
        [
          { text: 'Datum', style: 'field', margin: [0,0,0,0] }, 
          { text: `${new Date().toLocaleDateString()}`, style: 'subHeader', margin: [0,0,0,0] },
        ],
        { text: 'Godkännes', style: 'field' }, 
        { text: 'Attest', style: 'field' }, 
      ]

      const docDefinition = {
        pageOrientation: 'portrait',
        pageSize: 'A4',
        content: [
          { text: 'BOKFÖRINGSORDER', style: 'mainHeader', bold: false },
          {
            table: {
              headerRows: 1,
              widths: [100, 140, 140, 100, 100],
              body: [
                tableHeaders,
              ],
            }
          },
          {
            table: {
              headerRows: 1,
              widths: [100, 65.5, 65.5, 140, 100],
              body: [
                [
                  { text: 'Konto', style: 'field', margin: [0,0,0,0] }, 
                  { text: 'Resultat', style: 'field', margin: [0,0,0,0] }, 
                  { text: 'Projekt', style: 'field', margin: [0,0,0,0] }, 
                  { text: 'Debet kr', style: 'field', margin: [0,0,0,0] }, 
                  { text: 'Kredit kr', style: 'field', margin: [0,0,0,0] }, 
                ],
              ]
            }
          },
          {
            table: {
              headerRows: 1,
              widths: [507],
              body: [
                [
                  { text: 'Ersättningskort', fontSize: '12', margin: [0, 20, 0, 0] }
                ]
              ]
            }
          },
          {
            table: {
              headerRows: 1,
              widths: [100, 65.5, 65.5, 100, 140, 100],
              body: [
                [
                  { text: '1930', style: 'subHeader', margin: [75, 20, 0, 0] },
                  { text: '' },
                  { text: '' },
                  { text: totalPrice < 1 ? null : formatCurrency(totalPrice), style: ['subHeader', 'alignRight'], margin: [0,20,0,0] },
                  { text: '' },
                ],
                [
                  { text: '3524', style: 'subHeader', margin: [75, 20, 0, 0] },
                  { text: '', style: 'subHeader', margin: [45, 20, 0, 0] },
                  { text: '2020', style: 'subHeader', margin: [40, 20, 0, 0] },
                  { text: '' },
                  { text: totalPrice < 1 ? null : formatCurrency(priceWithoutVat), style: ['subHeader', 'alignRight'], margin: [0,20,0,0] },
                  { text: '' },
                ],
                [
                  { text: '2611', style: 'subHeader', margin: [75, 20, 0, 0] },
                  { text: '', style: 'subHeader', margin: [45, 20, 0, 0] },
                  { text: '', style: 'subHeader', margin: [40, 20, 0, 0] },
                  { text: '' },
                  { text: totalPrice < 1 ? null : formatCurrency(vatAmount), style: ['subHeader', 'alignRight'], margin: [0,20,0,0] },
                  { text: '' },
                ]
              ]
            }
          },
          { text: '', style: 'header', margin: [0,0,0,80] },
        ],
        styles: {
          mainHeader: {
            fontSize: 18,
            font: 'Dosis',
            margin: [0, -20, 0, 40],
            bold: true,
            alignment: 'center'
          },
          header: {
            fontSize: 18,
            font: 'Dosis',
            margin: [0, 0, 0, 10],
            characterSpacing: 2
          },
          subheader: {
            fontSize: 12,
            margin: [0, 0, 0, 0],
          },
          fieldLabel: {
            fontSize: 7,
            font: 'Dosis',
            margin: [0, 10, 0, 2],
            characterSpacing: 1.0,
            bold: true,
          },
          field: {
            margin: [0, 0, 0, 20],
            fontSize: 9,
          },
          fieldAddress: {
            margin: [0, 0, 0, 0],
          },
          fieldLabelOrderDate: {
            fontSize: 7,
            font: 'Dosis',
            margin: [-14, 10, 0, 0],
            characterSpacing: 1.8
          },
          fieldOrderDate: {
            margin: [-14, 2, 0, 0],
          },
          tableHeader: {
            fontSize: 10,
            font: 'Dosis',
            bold: true,
            margin: [0, 8, 8, 4],
          },
          tableRow: {
            margin: [0, 8, 8, 4],
          },
          tableFooter: {
            margin: [0, 14, 8, 0],
            bold: true,
          },
          alignRight: {
            alignment: 'right'
          }
        },
        defaultStyle: {
          fontSize: 10,
          font: 'OpenSans',
          color: '#3b3c3a',
        },
      };

      docDefinition.content.push({
        layout: 'lightHorizontalLines',
        table: {
          headerRows: 1,
          widths: [80, 80, 80, 80, 40, 78],

          body: [
            mappedHeaders,
            ...mappedOrders,
          ],
        }
      })

      pdfMake.createPdf(docDefinition).print();
    },

    printInvoice(order) {

      const orderPrice = get(order, 'price', '')
      const orderPaidDate = Sugar.Date(new Date(get(order, 'createdAt', null))).format('%Y-%m-%d')
      const contactPerson = `${get(order, 'createdBy.firstName', '')} ${get(order, 'createdBy.lastName', '')}`
      const companyName = `${get(order, 'company.name', '')}`
      let zipCode = get(order, 'invoiceZipCode', '') || get(order, 'deliveryZipCode', '')
      const formattedZipcode = formatZipCode(zipCode)
      const recipientAddress = `${get(order, 'invoicePostalAddress', '')}\n ${formattedZipcode} ${get(order, 'invoiceCity', '')}\n`
      const deliveryAddress = `${get(order, 'deliveryPostalAddress', '')}\n ${formattedZipcode} ${get(order, 'deliveryCity', '')}\n`
      const invoiceAddress = (recipientAddress === true ? recipientAddress : deliveryAddress)
      const orderBelongsToPerson = `${get(order, 'print.person.firstName', '')} ${get(order, 'print.person.lastName', '')}`
      const deliveryAttention = get(order, 'deliveryAttention', '')
      const formattedInvoiceAddress = `${((deliveryAttention && companyName) ? deliveryAttention : companyName) || orderBelongsToPerson}\n${invoiceAddress}`
      const printType = get(order, 'printType', 'MachineCertificate') === 'TradeCertificate' ? 'Yrkesbevis – ersättningskort' : 'Maskinkort'

      const dueDate = `${Sugar.Date.addDays(new Date(orderPaidDate), 15)}`
      const ourReference = `${contactPerson}`
      const refersTo = `${get(order, 'print.person.firstName', '')} ${get(order, 'print.person.lastName', '')}`

      const docDefinition = {
        pageOrientation: 'portrait',
        pageSize: 'A4',
        content: [
          {
            columns: [
              {
                svg: BYN_LOGO,
                width: 250,
              },
              {
                columns: [
                  [
                    { text: 'Faktura', style: 'mainHeader' },
                    { text: '', style: 'marginBottom' },
                    { columns: [
                      [
                        { text: 'Fakturanummer', style: 'label', margin: [0, -10, 0, 0] },
                        { text: get(order, 'orderId', null), style: 'fieldLabel' },
                      ],
                      [
                        { text: 'Fakturadatum', style: 'label', margin: [0, -10, 0, 0] },
                        { text: `${orderPaidDate}`, style: 'fieldLabel' },
                      ]
                    ]},
                    { text: '', style: 'marginBottom' },
                    [
                      { text: 'Fakturadress', style: 'label', margin: [0, -10, 0, 0] },
                      { text: formattedInvoiceAddress, style: 'fieldLabel' },
                    ]
                  ],
                ]
              },
            ],
            columnGap: 60
          },
          { text: '', style: 'marginTop' },
          {
            columns: [
              { text: '', style: 'label', width: 250 },
              [
                { text: 'Vår referens', style: 'label' },
                { text: '', margin: [0,0,0,10] },
                { text: 'Betalningsvilkor', style: 'label' },
                { text: '', margin: [0,0,0,10] },
                { text: 'Förfallodatum', style: 'label' },
              ],
              [
                { text: ourReference, style: 'label' },
                { text: '', margin: [0,0,0,10] },
                { text: '15 dagar netto', style: 'label' },
                { text: '', margin: [0,0,0,10] },
                { text: `${Sugar.Date(dueDate).format('%Y-%m-%d')}`, style: 'label' },
              ]
            ],
            columnGap: 60
          },
          { text: '', margin: [0, 40, 0, 0] },
          {
            columns: [
              { text: 'Benämning', style: 'label', width: 270 },
              { text: 'Lev ant Enh', style: 'label' },
              { text: 'à-pris', style: 'label' },
              { text: 'Summa', style: 'label' },
            ],
            columnGap: 40
          },
          { canvas: [{ type: 'line', x1: 0, y1: 5, x2: 514, y2: 5, lineWidth: 0.5, lineColor: '#aaa' }] },
          { text: '', margin: [0, 5, 0, 0] },
          {
            columns: [
              { text: printType, style: 'label', width: 270, fontSize: 10 },
              { text: '1', style: 'label', alignment: 'center' },
              { text: '360 kr', style: 'label' },
              { text: formatCurrency(orderPrice), style: 'label' },
            ],
            columnGap: 40
          },
          { text: '', margin: [0, 5, 0, 0] },
          { text: `Avser: ${refersTo}`, style: 'fieldLabelMedium' },
          { text: '', margin: [0, 100, 0, 0] },
          { text: 'Beställningen kommer att hanteras då betalning inkommit.', style: 'fieldLabelMedium' },
          { text: 'Beställningen kommer att makuleras om betalning ej inkommit 5 arbetsdagar efter förfallodatum.', style: 'fieldLabelMedium' },
          { text: 'OBS! Vid betalning, ange fakturanummer. /Note, mark the payment with invoice number.', style: 'fieldLabelMedium', margin: [0, 10, 0, 0] },
          { text: 'IBAN account number: SE8680000832799948287553, Bic code: SWEDSESS', style: 'fieldLabelMedium' },
          { text: '', margin: [0, 50, 0, 0] },
          {
            columns: [
              { text: 'Netto', style: 'label' },
              { text: 'Moms %', style: 'label', alignment: 'center' },
              { text: 'Moms kr', style: 'label', alignment: 'center' },
              { text: 'ATT BETALA', style: 'label', bold: true, alignment: 'center' },
            ],
            columnGap: 40
          },
          { text: '', margin: [0, 2, 0, 0] },
          {
            columns: [
              { text: '360 kr', style: 'label' },
              { text: '25', style: 'label', alignment: 'center' },
              { text: orderPrice > 0 ? '90,00' : '0', style: 'label', alignment: 'center' },
              { text: formatCurrency(orderPrice), style: 'label', bold: true, alignment: 'center' },
            ],
            columnGap: 40
          },
          { text: '', margin: [0, 20, 0, 0] },
          { canvas: [{ type: 'line', x1: 0, y1: 5, x2: 514, y2: 5, lineWidth: 0.5, lineColor: '#aaa' }] },
          { text: '', margin: [0, 0, 0, 5] },
          {
            columns: [
              { text: 'Adress', style: 'labelSmall' },
              { text: 'Telefon', style: 'labelSmall' },
              { text: 'Bankgiro', style: 'labelSmall' },
              { text: 'Momsreg.nr', style: 'labelSmall' }
            ],
            columnGap: 40
          },
          {
            columns: [
              { text: 'BYN', style: 'label' },
              { text: '08-564 881 60', style: 'label' },
              { text: '5497-8366', style: 'label' },
              { text: 'SE802005823901', style: 'label' }
            ],
            columnGap: 40
          },
          {
            columns: [
              { text: 'Byggbranschens yrkesnämnd', style: 'label', fontSize: 8 },
              { text: '', style: 'label' },
              { text: 'Organisationsnr', style: 'labelSmall', fontSize: 8 },
              { text: 'Innehar F-skattebevis', style: 'label' }
            ],
            columnGap: 40
          },
          {
            columns: [
              { text: 'Box 42136', style: 'label' },
              { text: '', style: 'label' },
              { text: '802005-8239', style: 'label' },
              { text: '', style: 'label' }
            ],
            columnGap: 40
          },
          {
            columns: [
              { text: '126 15 STOCKHOLM', style: 'label' },
              { text: 'ekonomi@byn.se', style: 'label' },
              { text: 'www.byn.se', style: 'label' },
              { text: '', style: 'label' }
            ],
            columnGap: 40
          },
        ],
        styles: {
          mainHeader: {
            fontSize: 28,
            font: 'Dosis',
            margin: [0,-10,0,0]
          },
          label: {
            fontSize: 9,
            font: 'Dosis',
            margin: [0, 0, 0, 0]
          },
          fieldLabel: {
            fontSize: 12,
            font: 'Dosis',
            margin: [5, 0, 0, 0]
          },
          fieldLabelMedium: {
            fontSize: 10,
            font: 'Dosis'
          },
          labelSmall: {
            fontSize: 7,
            font: 'Dosis'
          },
          marginTop: {
            margin: [0,100,0,0]
          },
          marginBottom: {
            margin: [0,0,0,20]
          }
        }
      }      
      pdfMake.createPdf(docDefinition).print();
    }
  }
}

export default Prints